module.exports = __webpack_public_path__ + "img/202309_02.69c3774c.jpg";